import { Button, Collapse, PageHeader, Typography } from 'antd';
import React, { useState } from 'react';

import tanimoto from '../img/pageHelp/tanimoto.png';
import herbSearch from '../img/pageHelp/herbSearch.svg';
import ingredientSearch from '../img/pageHelp/ingredientSearch.svg';
import recipeSearch from '../img/pageHelp/recipeSearch.svg';
import targetSearch from '../img/pageHelp/targetSearch.svg';
import diseaseSearch from '../img/pageHelp/diseaseSearch.svg';

const { Panel } = Collapse;
const { Title } = Typography;

const PageHelp: React.FC = () => {
    const [background, setBackground] = useState<string[]>([]);
    const [howToUse, setHowToUse] = useState<string[]>([]);
    const [resources, setResources] = useState<string[]>([]);
    return (
        <div id="help content" className="helppage">
            <PageHeader title="Frequently Asked Questions" style={{ marginBottom: '5vh' }} />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ maxWidth: '900px', flexBasis: '900px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Title level={4} style={{ color: 'red' }}>
                            Glossary
                        </Title>
                        <div>
                            <Button
                                onClick={() => setBackground(['1', '2', '3', '4', '5', '6', '7'])}
                                type="link"
                                size="small"
                            >
                                Open All
                            </Button>
                            /
                            <Button onClick={() => setBackground([])} size="small" type="link">
                                Close All
                            </Button>
                        </div>
                    </div>
                    <Collapse
                        style={{ marginBottom: '5vh' }}
                        activeKey={background}
                        onChange={(e) => setBackground(e as string[])}
                    >
                        <Panel header="A-D" key="1">
                            <span style={{ fontWeight: 'bold' }}>Accepted botanical name</span>
                            <p>Correct scientific plant name</p>
                            <span style={{ fontWeight: 'bold' }}>ATC codes</span>
                            <p>
                                The Anatomical Therapeutic Chemical (ATC) classification system is used for the
                                classification of drugs. It is published by the World Health Organization (WHO). The
                                classification into groups is based on therapeutic and chemical characteristics of the
                                drugs.Each ATC code is divided into five levels:
                                <li>level 1: Anatomical main group</li>
                                <li>level 2: Therapeutic main group</li>
                                <li>level 3: Therapeutic/pharmacological subgroup</li>
                                <li>level 4: Chemical/therapeutic/pharmacological subgroup</li>
                                <li>level 5: Chemical substance</li>
                                Substances or combination of substances in the 5th level refer to a single indication.
                                Drugs having more than one indication belong to more than one ATC code. Aspirin for
                                example has 3 ATC codes assigned. Drugs having no ATC code assigned by the WHO were
                                given a pseudo-ATC class based on their primary indication areas. To assign pseudo-ATC
                                code an exhaustive literature search was carried out.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Botanicals</span>
                            <p>Useful plants in medicine and wellness.</p>
                            <span style={{ fontWeight: 'bold' }}>Botanical synonym</span>
                            <p>
                                Other botanical names that are actually the same plant as the one with the accepted
                                botanical name, which is used as the only standard name.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Chinese pharmaceutical name</span>
                            <p>Chinese name of a TCM drug.</p>
                            <span style={{ fontWeight: 'bold' }}>Chinese materia medica</span>
                            <p>
                                CMM, medicinal sources and products in China; a historical textual genre in Chinese; a
                                field of philological and scientific studies, which sort the identification of
                                pharmaceutical ingredients in a drug and trace the plant-parts and other sources back to
                                different names in the folk and historical literature, and authenticate simples
                                regarding regional availability, cultivation, processing, chemistry, and classification
                                on a taxonomic and encyclopedic scale.{' '}
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Chinese medicine</span>
                            <p>
                                Historical medicine in present-day China and earlier territories including neighboring
                                regions and imported medicinal materials. A particular feature is the strong historical
                                record of texts in East Asia about mixtures of drugs in a recipe. Moreover, the broad
                                term includes manual treatments such as acupuncture and moxibustion, minor surgery,
                                divination, as well as breathing, meditation and body techniques such as Qigong,
                                Specifically, Chinese materia medica (CMM) studies are yet another strand of Chinese
                                medicine.{' '}
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Common pharmaceutical name</span>
                            <p>
                                Names of drugs and botanicals used in pharmacy, often giving the plant part and
                                processing method, but under-standardized and often unscientific plant names or
                                botanical synonyms.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Common plant name</span>
                            <p>Vernacular names for plants and botanicals.</p>
                            <span style={{ fontWeight: 'bold' }}>Druggable targets</span>
                            <p>
                                They are a set of proteins that is potentially modulated by a drug-like small molecule
                                and has been predicted on the basis of sequence and structural similarity to the targets
                                of existing drugs.
                            </p>
                        </Panel>
                        <Panel header="E-H" key="2">
                            <span style={{ fontWeight: 'bold' }}>E-Value</span>
                            <p>
                                The Expect value (E) to randomly hit one of the current 254 pathways with a p-value.
                                <br />
                                E-value = 1-(1-p)<sup>254</sup>
                                <br />
                                If p-value = 0.01, then E-value = 1-(1-0.01)<sup>254</sup> = 0.92
                                <br />
                                That means, there is the chance of 92% to randomly hit one of the 254 pathways with the
                                p-value of 0.01. Therefore, hitting a pathway with p-value of 0.01 by chance is not very
                                unlikely.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>“Herb”</span>
                            <p>
                                A processed medicinal drug product; a simple remedy. We use the term for plant-based
                                products only, while some animal, mineral and fungal sources are widely used to in
                                mainstream TCM.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>“Herbs”: </span>
                            <p>Multiple “herbs”; a mixed remedy.</p>
                        </Panel>
                        <Panel header="I-L" key="3">
                            <span style={{ fontWeight: 'bold' }}>Ingredient</span>
                            <p>
                                Molecular compound, including pharmaceutical active ingredients. As opposed to
                                ingredients in a Chinese pharmaceutical recipe product.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>ICD-10-CM code</span>
                            <p>International Classification of Diseases, Tenth Revision, Clinical Modification.</p>
                            <span style={{ fontWeight: 'bold' }}>KEGG pathways</span>
                            <p>
                                The KEGG (Kyoto Encyclopedia of Genes and Genomes) is a collection of database resources
                                for linking genomes to life and the environment. KEGG Pathway provides a collection of
                                manually drawn pathway maps which visualize molecular interaction and reaction networks.
                                Current total number of KEGG pathways is 544, but we only keep the pathways that are
                                related to diseases or infections. Therefore, the total number of pathways that can be
                                found in our website is 254.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>KEGG global maps</span>
                            <p>
                                Three global maps: Metabolic pathways, Biosynthesis of secondary metabolites and
                                Microbial metabolism in diverse environments can be found in the KEGG website. 162, 74
                                and 41 related pathways were integrated into these three global maps respectively to
                                give an overview in the biological system. The global maps were redesigned in iPath3.0,
                                an interactive pathways explorer that allows users to easily navigate and explore the
                                complex pathway maps. The related ingredient and target information of the specific
                                herbs or recipes are marked in the global maps to show users how they affect the
                                pathways via iPath3.0.
                            </p>
                        </Panel>
                        <Panel header="M-P" key="4">
                            <span style={{ fontWeight: 'bold' }}>Pharmacological action</span>
                            <p>
                                The targets with the pharmacological action for the specific diseases bind to at least
                                one approved drug.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Principle Formula</span>
                            <p>
                                The main standard TCM pharmaceutical recipes, which are often modified case by case for
                                a patient in the course of her treatment.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>P-value</span>
                            <p>
                                A probability that the targets of a specific ingredients/herb/recipe affect a specific
                                pathway by chance. The smaller the p-value, the better.
                            </p>
                        </Panel>
                        <Panel header="Q-T" key="5">
                            <span style={{ fontWeight: 'bold' }}>Recipe (Chinese pharmaceutical recipe)</span>
                            <p>
                                Pharmaceutical mixture of Chinese processed medicinal remedies/“herbs” in a mixed remedy
                                product. (For popular standard recipes refer to Principle Formula).
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Scientific names</span>
                            <p>
                                Scientific names are latin plant names that are accepted and used worldwide as a means
                                of classifying or identifying specific plants.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>SMILES</span>
                            <p>
                                The simplified molecular-input line-entry system (SMILES) is a specification in the form
                                of a line notation for describing the structure of chemical species using short ASCII
                                strings. SMILES strings are 1D descriptor of the molecules that can be imported by most
                                molecule editors for conversion back into 2D drawings or 3D models of the molecules.
                            </p>
                            <span style={{ fontWeight: 'bold' }}>Traditional Chinese Medicine, TCM</span>
                            <p>
                                Traditional Chinese Medicine is a widely used term in global science and trade, but the
                                term is widely rejected by historians, philologists and anthropologists due to its
                                translation history in early communist China and during the post-Maoist globalization
                                process, which is centred on standards following the mainland Chinese regulations of the
                                People`s Republic of China. (For alternative terms refer to: Chinese medicine.)
                            </p>
                            <span style={{ fontWeight: 'bold' }}>TCM disease name</span>
                            <p>= Principle Formula; = Chinese recipe name</p>
                            <span style={{ fontWeight: 'bold' }}>Transliteration</span>
                            <p>
                                Phonological transliterated name of Chinese characters in Latin letters, called “pinyin”
                                in Chinese.
                            </p>
                        </Panel>
                        <Panel header="U-Z" key="6">
                            <p></p>
                        </Panel>
                        <Panel header="Others" key="7">
                            <span style={{ fontWeight: 'bold' }}>2D similarity</span>
                            <p>
                                2D similarity of two molecules is calculated by estimating the Tanimoto coefficient.
                                First, the molecules are converted into molecular fingerprints (bit vector
                                representations) which are then compared to obtain a Tanimoto score (0 to 1.0) as
                                follows:
                            </p>
                            <img src={tanimoto} style={{ maxWidth: '300px' }} />

                            <p>
                                where AB is the number of bits set to one in both molecules, A is the number of bits set
                                to one in molecule A and B is the number of bits set to one in molecule B. A Tanimoto
                                close to 1.0 indicates excellent similarity.
                            </p>
                        </Panel>
                    </Collapse>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Title level={4} style={{ color: 'red' }}>
                            How To Use
                        </Title>
                        <div>
                            <Button onClick={() => setHowToUse(['1', '2', '3', '4', '5'])} type="link" size="small">
                                Open All
                            </Button>
                            /
                            <Button onClick={() => setHowToUse([])} size="small" type="link">
                                Close All
                            </Button>
                        </div>
                    </div>
                    <Collapse
                        activeKey={howToUse}
                        onChange={(e) => setHowToUse(e as string[])}
                        style={{ marginBottom: '5vh' }}
                    >
                        <Panel header="Plant/Herb Search" key="1">
                            <p>
                                1. Type in any string, for example “raspberry”, and a list of possible matches will
                                appear in the drop down box under 5 possible headings. You can select a specific one or
                                <br />
                                2. show all related results. If you select European raspberry for example,
                                <br />
                                3. you will be taken to the Network Page of this plant. Where you can see the network of
                                the plant and 5 different properties - botanical synonyms, plant common name, Chinese
                                pharmaceutical name, pharmaceutical latin name and pinyin. To see or to hide each graph
                                node, click on and off the heading. Here you can see from the Chinese pharmaceutical
                                name there are two items which signifies two Chinese herbs from this plant can be found
                                in our database. By clicking the terms underlined in red, you will be directed to plant
                                or herb detailed page.
                                <br />
                                4. In the herb page you can firstly see its image and basic information.
                                <br />
                                5. Here are the metabolic pathways, where the ingredients and targets from this herb are
                                presented on the map. When you click on this image, you are redirected to iPath3 where
                                you can access an interactive version of the map. By clicking on the ingredient or
                                target more detailed information is displayed. If you click the number of hits you can
                                see the affects of the ingredient or target highlighted in the map. This information can
                                then be seen in this box which allows you to select another map and see how the data
                                impacts that map.
                                <br />
                                Other aspect of this website are (1) the related ingredients are provided as well as
                                their basic properties and ATC code. (2) the related targets, with their identifiers and
                                two additional tags - pharmacological action and druggable. (3))And, the related
                                pathways are provided sorted by p-value or e-value.
                            </p>

                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
                                <img src={herbSearch} alt="herb Search" style={{ width: '100%' }} />
                            </div>
                        </Panel>
                        <Panel header="Recipe Search" key="2">
                            <p>
                                If you want to search for a recipe, you can do so by using its Chinese Name, Pinyin or
                                its English Name. It can also be searched for via actions or treatment strategies. Once
                                you select a recipe, similar information is provided as you saw with the herb.
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
                                <img src={recipeSearch} alt="recipe Search" style={{ width: '100%' }} />
                            </div>
                        </Panel>
                        <Panel header="Ingredient Search" key="3">
                            <p>
                                1. You can search for an ingredient by using any compound name from PubChem or its
                                SMILES. Alternatively, you can draw the structure to find a similar ingredient in the
                                database.
                                <br />
                                2. In a few seconds a list of these ingredients with the tanimoto value and structure
                                will be displayed.
                                <br />
                                3. You can click on the show details to see more information about the specific
                                ingredient.
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
                                <img src={ingredientSearch} alt="ingredient Search" style={{ width: '100%' }} />
                            </div>
                        </Panel>
                        <Panel header="Target Search " key="4">
                            <p>
                                If you have the names of the protein you can use the target search to find the related
                                ingredients and the corresponding herb/plant page and its information.
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
                                <img src={targetSearch} alt="target Search" style={{ width: '100%' }} />
                            </div>
                        </Panel>
                        <Panel header="Disease Search" key="5">
                            <p>
                                You can search using the disease name to find the related ingredients and corresponding
                                herb/plant page and its information
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '2% 5%' }}>
                                <img src={diseaseSearch} alt="disease Search" style={{ width: '100%' }} />
                            </div>
                        </Panel>
                    </Collapse>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Title level={4} style={{ color: 'red' }}>
                            Partner and the resources
                        </Title>
                        <div>
                            <Button onClick={() => setResources(['1', '2', '3'])} type="link" size="small">
                                Open All
                            </Button>
                            /
                            <Button onClick={() => setResources([])} size="small" type="link">
                                Close All
                            </Button>
                        </div>
                    </div>
                    <Collapse
                        style={{ marginBottom: '5vh' }}
                        activeKey={resources}
                        onChange={(e) => setResources(e as string[])}
                    >
                        <Panel header="Partner" key="1">
                            <p>
                                <a
                                    href={'https://mpns.science.kew.org/mpns-portal/'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Medicinal Plant Names Services: MPNS
                                </a>{' '}
                            </p>
                        </Panel>
                        <Panel header="Source Databases" key="2">
                            <p>
                                Plant database:
                                <a
                                    href={'https://mpns.science.kew.org/mpns-portal/'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    MPNS,
                                </a>{' '}
                                <a
                                    href={'https://www.ncbi.nlm.nih.gov/taxonomy'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    NCBI Taxonomy
                                </a>{' '}
                            </p>
                            <p>
                                Chemical databases:
                                <a href={'https://pubchem.ncbi.nlm.nih.gov/'} target="_blank" rel="noopener noreferrer">
                                    PubChem,
                                </a>{' '}
                                <a href={'https://www.ebi.ac.uk/chembl/'} target="_blank" rel="noopener noreferrer">
                                    ChEMBL
                                </a>{' '}
                            </p>
                            <p>
                                Target related databases:
                                <a href={'https://www.uniprot.org/'} target="_blank" rel="noopener noreferrer">
                                    UnitProt,
                                </a>{' '}
                                <a href={'https://www.ebi.ac.uk/chembl/'} target="_blank" rel="noopener noreferrer">
                                    ChEMBL,
                                </a>{' '}
                                <a
                                    href={'https://www.genome.jp/kegg/pathway.html'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    KEGG
                                </a>{' '}
                            </p>
                            <p>
                                Pathway related databases:
                                <a
                                    href={'https://www.genome.jp/kegg/pathway.html'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    KEGG,
                                </a>{' '}
                                <a href={'https://pathways.embl.de/'} target="_blank" rel="noopener noreferrer">
                                    iPath3.0,
                                </a>{' '}
                            </p>
                            <p>
                                Disease related database:
                                <a href={'http://db.idrblab.net/ttd/'} target="_blank" rel="noopener noreferrer">
                                    TTD
                                </a>{' '}
                            </p>
                        </Panel>
                        <Panel header="Software and Tools" key="3">
                            <p>
                                Web-interface:
                                <a href={'https://reactjs.org/'} target="_blank" rel="noopener noreferrer">
                                    React JS,
                                </a>{' '}
                                <a href={'https://www.typescriptlang.org/'} target="_blank" rel="noopener noreferrer">
                                    Typescript,
                                </a>{' '}
                                <a href={'https://ant.design/'} target="_blank" rel="noopener noreferrer">
                                    Ant Design,
                                </a>{' '}
                                <a
                                    href={'https://www.php.net/manual/en/book.pdo.php'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    PHP Data Objects,
                                </a>{' '}
                                <a href={'https://www.python.org/'} target="_blank" rel="noopener noreferrer">
                                    Python,
                                </a>{' '}
                            </p>
                            <p>
                                Cheminformatics tools:
                                <a href={'https://www.chemdoodle.com/'} target="_blank" rel="noopener noreferrer">
                                    ChemDoodle,
                                </a>{' '}
                                <a href={'https://www.rdkit.org/'} target="_blank" rel="noopener noreferrer">
                                    RDKit
                                </a>{' '}
                            </p>
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </div>
    );
};

export default PageHelp;
